import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getConfigName, usaAuthV2 } from "@helpers/funciones";

interface Props {
  /** Ruta v2 equivalente (`PATHS_AUTH_V2`). */
  to: string;
  /** La pantalla v1, para las empresas que todavía no usan el acceso v2. */
  children: ReactNode;
}

/**
 * Ruta de acceso v1 (login, recuperar y nueva contraseña): si la empresa ya usa el acceso v2 (`EMPRESAS_AUTH_V2`) la
 * manda a su versión v2 conservando el query (ej. `?request=` de la liga de nueva contraseña); si no, muestra la v1.
 */
export const RedirectAuthV2 = ({ to, children }: Props) => {
  const location = useLocation();

  if (usaAuthV2(getConfigName(window.location.href))) {
    return <Navigate to={`${to}${location.search}`} state={location.state} replace />;
  }

  return <>{children}</>;
};
